export const DOMAIN = '#{DOMAIN}';
export const BOT_DOMAIN = '#{BOT_DOMAIN}';
export const BLIP_DOMAIN = '#{BLIP_DOMAIN}';
export const MEDIA_DOMAIN = '#{MEDIA_DOMAIN}';
export const HOSTNAME = '#{HOSTNAME}';
export const HOSTNAME_TENANT_DEFAULT = '#{HOSTNAME_TENANT_DEFAULT}';
export const PORT = '#{PORT}';
export const ALLOWED_DOMAINS = '#{ALLOWED_DOMAINS}';
export const APPINSIGHTS_INSTRUMENTATION_KEY = '#{APPINSIGHTS_INSTRUMENTATION_KEY}';
export const APPINSIGHTS_CLOUD_COMPONENT_NAME = '#{APPINSIGHTS_CLOUD_COMPONENT_NAME}';
export const SENTRY_DSN = '#{SENTRY_DSN}';
export const GOOGLE_ANALYTICS_ID = '#{GOOGLE_ANALYTICS_ID}';


// WEBPACK FOOTER //
// ./src/settings.js